import { useState } from 'react';
import api from '../../services/api';
import useCurrentUser from '../../hooks/useCurrentUser';
import Modal from './Modal';

export default function BugReportButton() {
    const currentUser = useCurrentUser();
    const [showModal, setShowModal] = useState(false);
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async () => {
        if (!message.trim()) return;
        setSending(true);
        try {
            await api.post('/bug_reports', {
                auteur: currentUser?.nom || currentUser?.email || 'Inconnu',
                message: message.trim(),
            }, { headers: { 'Content-Type': 'application/ld+json' } });
            setSent(true);
            setMessage('');
            setTimeout(() => {
                setSent(false);
                setShowModal(false);
            }, 2000);
        } catch (err) {
            console.error(err);
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            {/* Bouton flottant */}
            <button
                onClick={() => setShowModal(true)}
                title="Signaler un bug"
                style={{
                    position: 'fixed',
                    bottom: '24px',
                    right: '24px',
                    zIndex: 999,
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: '#ef4444',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(239,68,68,0.4)',
                    fontSize: '20px',
                }}
            >
                <i className="ti ti-bug" />
            </button>

            {/* Modale */}
            {showModal && (
                <Modal title="Signaler un bug" onClose={() => setShowModal(false)}>
                    {sent ? (
                        <div style={{ textAlign: 'center', padding: '20px', color: '#16a34a' }}>
                            <i className="ti ti-check" style={{ fontSize: '32px', display: 'block', marginBottom: '8px' }} />
                            Message envoyé, merci !
                        </div>
                    ) : (
                        <div>
                            <div style={{ marginBottom: '16px', fontSize: '13px', color: '#888' }}>
                                <i className="ti ti-user" style={{ marginRight: '6px' }} />
                                {currentUser?.nom || currentUser?.email}
                                <span style={{ marginLeft: '12px' }}>
                                    <i className="ti ti-clock" style={{ marginRight: '4px' }} />
                                    {new Date().toLocaleString('fr-FR')}
                                </span>
                            </div>
                            <textarea
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                                placeholder="Décrivez le problème rencontré..."
                                rows={5}
                                style={{
                                    width: '100%',
                                    padding: '10px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    fontSize: '14px',
                                    resize: 'vertical',
                                    boxSizing: 'border-box',
                                    fontFamily: 'inherit',
                                    marginBottom: '16px',
                                }}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button onClick={() => setShowModal(false)} style={{
                                    padding: '8px 16px', borderRadius: '8px', border: '1px solid #ddd',
                                    backgroundColor: 'white', cursor: 'pointer', fontSize: '13px',
                                }}>
                                    Annuler
                                </button>
                                <button onClick={handleSubmit} disabled={sending || !message.trim()} style={{
                                    padding: '8px 16px', borderRadius: '8px', border: 'none',
                                    backgroundColor: sending ? '#fca5a5' : '#ef4444',
                                    color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '600',
                                }}>
                                    {sending ? 'Envoi...' : 'Envoyer'}
                                </button>
                            </div>
                        </div>
                    )}
                </Modal>
            )}
        </>
    );
}